import { render, staticRenderFns } from "./ListLessons.vue?vue&type=template&id=0bfdf4b8&"
import script from "./ListLessons.vue?vue&type=script&lang=js&"
export * from "./ListLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports